export default __webpack_public_path__ + "static/media/finishOrder2.677e2357.png";